"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RejectAttestationResponseToJSON = exports.RejectAttestationResponseFromJSONTyped = exports.RejectAttestationResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
function RejectAttestationResponseFromJSON(json) {
    return RejectAttestationResponseFromJSONTyped(json, false);
}
exports.RejectAttestationResponseFromJSON = RejectAttestationResponseFromJSON;
function RejectAttestationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': !(0, runtime_1.exists)(json, 'success') ? undefined : json['success'],
        'attestationId': !(0, runtime_1.exists)(json, 'attestationId') ? undefined : json['attestationId'],
        'rejectionReason': !(0, runtime_1.exists)(json, 'rejectionReason') ? undefined : json['rejectionReason'],
        'message': !(0, runtime_1.exists)(json, 'message') ? undefined : json['message'],
    };
}
exports.RejectAttestationResponseFromJSONTyped = RejectAttestationResponseFromJSONTyped;
function RejectAttestationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'attestationId': value.attestationId,
        'rejectionReason': value.rejectionReason,
        'message': value.message,
    };
}
exports.RejectAttestationResponseToJSON = RejectAttestationResponseToJSON;
